import AuthGuard from "./auth/AuthGuard";
import RoleBasedGuard from "./auth/RoleBasedGuard";
import MatxLayout from "./components/MatxLayout/MatxLayout";
import { PATH } from "../config";
import { WEB_PAGES } from "./views";
// import Dashboard from '../app/views/dashboard/index';

const routes = [
  {
    path: PATH.LOGIN,
    element: <WEB_PAGES.LOGIN />,
  },
  {
    path: PATH.FORGOTPASSWORD,
    element: <WEB_PAGES.FORGOTPASSWORD />,
  },
  {
    path: PATH.RESETPASSWORD,
    element: <WEB_PAGES.RESETPASSWORD />,
  },
  {
    element: (
      <AuthGuard>
        <MatxLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: PATH.DASHBOARD,
        element: <WEB_PAGES.DASHBOARD />,
      },
      {
        path: PATH.PROFILE,
        element: <WEB_PAGES.PROFILE />,
      },
      {
        path: PATH.CheckInOut,
        element: <WEB_PAGES.CheckInOut />,
      },
      {
        path: PATH.ALLREQUESTS,
        element: <WEB_PAGES.ALLREQUESTS />,
      },
      {
        path: PATH.CREATEREQUEST,
        element: <WEB_PAGES.CREATEREQUEST />,
      },
      {
        path: `${PATH.EDITREQUEST}`,
        element: <WEB_PAGES.EDITREQUEST />,
      },
     
      {
        path: "/view-request/:id",
        element: (
          <RoleBasedGuard allowedRoles={["admin", "teamlead", "employee"]}>
            <WEB_PAGES.VIEWREQUEST />
          </RoleBasedGuard>
        ),
      },
      
      {
        path: PATH.AllCHECK,
        element: (
          <RoleBasedGuard allowedRoles={["admin", "teamlead", "employee"]}>
            <WEB_PAGES.ALLCHECK /> 
          </RoleBasedGuard>
        ),
      },
      {
        path: PATH.AllCHECK,
        element: (
          <RoleBasedGuard allowedRoles={["admin", "employee"]}>
            <WEB_PAGES.ALLCHECK />
          </RoleBasedGuard>
        ),
      },
      {
        path: PATH.MYCHECKS,
        element: (
          <RoleBasedGuard allowedRoles={["teamlead"]}>
            <WEB_PAGES.ALLCHECK />
          </RoleBasedGuard>
        ),
      },
      {
        path: PATH.TEAMCHECKS,
        element: (
          <RoleBasedGuard allowedRoles={["teamlead"]}>
            <WEB_PAGES.ALLCHECK />
          </RoleBasedGuard>
        ),
      },
      {
        path: PATH.CREATECHECK,
        element: (
          <RoleBasedGuard allowedRoles={["admin", "teamlead", "employee"]}>
            <WEB_PAGES.CREATECHECK />
          </RoleBasedGuard>
        ),
      },
      {
        path: PATH.ALLREQUESTS,
        element: (
          <RoleBasedGuard allowedRoles={["admin", "teamlead", "employee"]}>
            <WEB_PAGES.ALLREQUESTS />
          </RoleBasedGuard>
        ),
      },
      {
        path: PATH.ALLMYREQUESTS,
        element: (
          <RoleBasedGuard allowedRoles={["admin", "teamlead", "employee"]}>
            <WEB_PAGES.AllMyRequests />
          </RoleBasedGuard>
        ),
      },
      {
        path: PATH.CREATEREQUEST,
        element: (
          <RoleBasedGuard allowedRoles={["admin", "teamlead", "employee"]}>
            <WEB_PAGES.CREATEREQUEST />
          </RoleBasedGuard>
        ),
      },
      {
        path: PATH.EDITREQUEST,
        element: (
          <RoleBasedGuard allowedRoles={["admin", "teamlead", "employee"]}>
            <WEB_PAGES.EDITREQUEST />
          </RoleBasedGuard>
        ),
      },
      {
        path: `${PATH.EDITCHECK}`,
        element: (
          <RoleBasedGuard allowedRoles={["admin", "teamlead", "employee"]}>
            <WEB_PAGES.EDITCHECK />
          </RoleBasedGuard>
        ),
      },
      {
        path: PATH.ALLEMPLOYEES,
        element: (
          <RoleBasedGuard allowedRoles={["admin"]}>
            <WEB_PAGES.ALLEMPLOYEES />
          </RoleBasedGuard>
        ),
      },
      {
        path: `${PATH.CREATEEMPLOYEE}`,
        element: (
          <RoleBasedGuard allowedRoles={["admin"]}>
            <WEB_PAGES.CREATEEMPLOYEE />
          </RoleBasedGuard>
        ),
      },
      {
        path: `${PATH.EDITEMPLOYEE}`,
        element: (
          <RoleBasedGuard allowedRoles={["admin"]}>
            <WEB_PAGES.EDITEMPLOYEE />
          </RoleBasedGuard>
        ),
      },
      {
        path: `${PATH.ALLANOUNCEMENTS}`,
        element: (
          <RoleBasedGuard allowedRoles={["admin"]}>
            <WEB_PAGES.Announcements />
          </RoleBasedGuard>
        ),
      },
      {
        path: `${PATH.ADDANOUNCEMENTS}`,
        element: (
          <RoleBasedGuard allowedRoles={["admin"]}>
            <WEB_PAGES.CreateAnnouncement />
          </RoleBasedGuard>
        ),
      },
      {
        path: `${PATH.EDITANOUNCEMENTS}`,
        element: (
          <RoleBasedGuard allowedRoles={["admin"]}>
            <WEB_PAGES.EditAnnouncement />
          </RoleBasedGuard>
        ),
      },

      {
        path: `${PATH.ALLHOLIDAYS}`,
        element: (
          <RoleBasedGuard allowedRoles={["admin"]}>
            <WEB_PAGES.Holidays />
          </RoleBasedGuard>
        ),
      },
      {
        path: `${PATH.ADDHOLIDAYS}`,
        element: (
          <RoleBasedGuard allowedRoles={["admin"]}>
            <WEB_PAGES.CreateHoliday />
          </RoleBasedGuard>
        ),
      },
      {
        path: `${PATH.EDITHOLIDAYS}`,
        element: (
          <RoleBasedGuard allowedRoles={["admin"]}>
            <WEB_PAGES.EditHoliday />
          </RoleBasedGuard>
        ),
      },
      {
        path: `${PATH.DELETED_EMPLOYEES}`,
        element: (
          <RoleBasedGuard allowedRoles={["admin"]}>
            <WEB_PAGES.DeletedEmployees />
          </RoleBasedGuard>
        ),
      },
      {
        path: PATH.VIEWEMPLOYEE,
        element: (
          <RoleBasedGuard allowedRoles={["admin"]}>
            <WEB_PAGES.VIEWEMPLOYEE />
          </RoleBasedGuard>
        ),
      },
      {
        path: PATH.MACHINELOGS,
        element: (
          <RoleBasedGuard allowedRoles={["admin", "teamlead"]}>
            <WEB_PAGES.UserMachineLogs />
          </RoleBasedGuard>
        ),
      },

      {
        path: PATH.ALLOVERTIMEREQUESTS,
        element: (
          <RoleBasedGuard allowedRoles={["admin", "teamlead", "employee"]}>
            <WEB_PAGES.ALLOVERTIMEREQUESTS />
          </RoleBasedGuard>
        ),
      },
      {
        path: PATH.VIEWOVERTIMEREQUEST,
        element: (
          <RoleBasedGuard allowedRoles={["admin", "teamlead", "employee"]}>
            <WEB_PAGES.VIEWOVERTIMEREQUEST />
          </RoleBasedGuard>
        ),
      },
      {
        path: PATH.CREATEOVERTIMEREQUEST,
        element: (
          <RoleBasedGuard allowedRoles={["admin",]}>
            <WEB_PAGES.CREATEOVERTIMEREQUEST />
          </RoleBasedGuard>
        ),
      },

      {
        path: PATH.EDITOVERTIMEREQUEST,
        element: (
          <RoleBasedGuard allowedRoles={["admin"]}>
            <WEB_PAGES.EDITOVERTIMEREQUEST />
          </RoleBasedGuard>
        ),
      },
    ],
  },
];

export default routes;
